module.exports = __webpack_public_path__ + "static/media/icon-gauge.8cc0da43.svg";